// extracted by mini-css-extract-plugin
module.exports = {"heroImageComponent":"styles_heroImageComponent__rMMS2"};